__turbopack_context__.v({
  "active": "Sidebar-module-scss-module__dgL8YG__active",
  "camStats": "Sidebar-module-scss-module__dgL8YG__camStats",
  "content": "Sidebar-module-scss-module__dgL8YG__content",
  "helpers": "Sidebar-module-scss-module__dgL8YG__helpers",
  "mainMenu": "Sidebar-module-scss-module__dgL8YG__mainMenu",
  "menu": "Sidebar-module-scss-module__dgL8YG__menu",
  "menuTopBar": "Sidebar-module-scss-module__dgL8YG__menuTopBar",
  "phase": "Sidebar-module-scss-module__dgL8YG__phase",
  "phaseGroupTitle": "Sidebar-module-scss-module__dgL8YG__phaseGroupTitle",
  "phaseTitle": "Sidebar-module-scss-module__dgL8YG__phaseTitle",
  "popup": "Sidebar-module-scss-module__dgL8YG__popup",
  "split": "Sidebar-module-scss-module__dgL8YG__split",
  "timelineLeft": "Sidebar-module-scss-module__dgL8YG__timelineLeft",
  "title": "Sidebar-module-scss-module__dgL8YG__title",
  "toc": "Sidebar-module-scss-module__dgL8YG__toc",
  "topSplit": "Sidebar-module-scss-module__dgL8YG__topSplit",
  "walkthrough": "Sidebar-module-scss-module__dgL8YG__walkthrough",
});
